// @ts-nocheck
import { HISTORY_ERROR, HISTORY_LOADING, HISTORY_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const HistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case HISTORY_LOADING:
            return Object.assign({}, state, { loading: true })
        case HISTORY_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case HISTORY_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

